<template>
    <div class="shop">
        <div>
            <div class="register-box" v-show="1 == isRegrster">
                <img class="store-img" :src="`${imgUrl}/common/new_store.jpg`" />
                <div class="btn-box">
                    <img class="open-img" :src="`${imgUrl}/register/1.png`" />
                    <div :class="[fixedBtn ? 'fixed-btn' : 'submit-btn']">
                        <div class="btn-animate btn" @click="settleIn">点击立刻0元开通</div>
                        <img class="finger-img pointer-move" src="../../assets/finger.png" />
                    </div>
                </div>
                <img class="intro-img" :src="`${imgUrl}/register/2.png`" />
                <img class="talk-img" :src="`${imgUrl}/register/3.png`" />
                <div class="store-show">
                    <div class="show-box">
                        <img class="icon" src="../../assets/store-title_icon.png" />
                        <img class="show-img" :src="`${imgUrl}/common/hfx.png`" />
                    </div>
                </div>
                <img class="desc-img" :src="`${imgUrl}/register/4.png`" />
                <div class="store-show">
                    <div class="show-box">
                        <img class="icon" src="../../assets/store-title_icon.png" />
                        <img class="show-img" :src="`${imgUrl}/common/hfx.png`" />
                    </div>
                </div>
            </div>
            <van-overlay :show="settleStatus" @click="settleStatus = false">
                <div class="c-success">
                    <div class="c-success-img">
                        <div class="c-success-close">
                            <img src="@/assets/close.png" alt="">
                        </div>
                        <div class="img-count">
                            <img class="img-count-img" src="@/assets/fu-success.png" alt="">
                        </div>
                    </div>
                    <div class="c-success-text">您已入驻吉祥有约</div>
                    <div class="c-success-btn">
                        <van-button
                            type="primary"
                            color="#0F50C5"
                            size="large"
                            @click="jumpApp"
                        >下载apk</van-button>
                    </div>
                </div>
            </van-overlay>
            <div class="shop-form" :class=" !showSaveBotton ? 'shop-hide' : ''" v-show="2 == isRegrster">
                <van-form @submit="submitUserData(smsCode, msgCodeStatus)">
                    <div class="shop-form-count" v-if="showProxySale">
                        <div class="shop-form-count-label shop-form-count-label-not">服务商名称</div>
                        <div class="shop-form-field" style="margin-left: 0;width: 100%;">
                            <van-field
                                clearable
                                v-model="fieldForm.proxySaleName"
                                placeholder="请输入服务商名称，没有填无"
                                input-align="left"
                                error-message-align="left"
                                @blur="onFieldBlur('fromAgentName', fieldForm.proxySaleName)"
                                @focus="hideBotton()"
                                type="text"
                            />
                        </div>
                    </div>
                    <div class="shop-form-line" v-if="showProxySale"></div>
                    <div class="shop-form-count shop-gap" v-if="showProxySale">
                        <div class="shop-form-count-label shop-form-count-label-not">门店销售品牌</div>
                        <div class="shop-form-field" style="margin-left: 0;width: 100%;">
                            <van-field
                                clearable
                                v-model="fieldForm.proxySaleBrand"
                                placeholder="请输入销售私密品牌名称，没有填无"
                                input-align="left"
                                error-message-align="left"
                                style="width: 240px;"
                                type="text"
                            />
                        </div>
                    </div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label">店老板姓名</div>
                        <!-- :rules="[{ required: true, message: '请输入店老板姓名' }]" -->
                        <div class="shop-form-field">
                            <van-field
                                v-model="fieldForm.bossName"
                                placeholder="请输入姓名"
                                input-align="left"
                                clearable
                                error-message-align="left"
                                style="width: 240px;"
                                @blur="onFieldBlur('bossName', fieldForm.bossName)"
                                @focus="hideBotton()"
                                type="text"
                            />
                        </div>
                    </div>
                    <div class="shop-form-line"></div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label">店老板手机号</div>
                        <!-- :rules="[{ required: true, message: '请输入店老板手机号' }]" -->
                        <div class="shop-form-field">
                            <van-field
                                v-model="fieldForm.bossPhone"
                                placeholder="请输入手机号"
                                input-align="left"
                                error-message-align="left"
                                style="width: 240px;"
                                clearable
                                type="tel"
                                :maxlength="11"
                                @update:model-value="verifyStore(fieldForm.bossPhone, fieldForm.storeName)"
                                @blur="onFieldBlur('bossPhone', fieldForm.bossPhone)"
                                @focus="hideBotton()"
                            />
                        </div>
                    </div>
                    <div class="shop-form-count">
                        <div class="shop-form-count-label">验证码</div>
                        <div class="shop-form-field">
                            <van-field
                                v-model="smsCode"
                                clearable
                                :maxlength="6"
                                label=""
                                type="tel"
                                input-align="left"
                                error-message-align="left"
                                placeholder="请输入短信验证码"
                                @update:model-value="verifyMsgCode(fieldForm.bossPhone, smsCode)"
                                @focus="hideBotton()"
                                @blur="onFieldBlur('---', '')"
                            >
                                <template #button>
                                    <div class="sms-btn" @click="getMsgCode(fieldForm.bossPhone)">{{ smsCodeText }}</div>
                                </template>
                            </van-field>
                        </div>
                    </div>
                    <div class="sms-code-tip" v-show="smsCode">
                        <img class="sms-tip-img" :src="require(smsCode.length === 6 && msgCodeStatus ? '../../assets/suc.png' : '../../assets/err.png')" />
                        <text :class="smsCode.length === 6 && msgCodeStatus ? 'suc-tip' : 'err-tip'">{{ smsCode.length === 6 && msgCodeStatus ? '手机号验证通过，请继续往下填写吧' : '验证码有误请重新输入' }}</text>
                    </div>
                    <div class="shop-form-line"></div>
                    <div class="shop-phone-tip shop-gap">💡 店老板的手机号将用于登录吉祥有约App</div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label">门店名称</div>
                        <!-- :rules="[{ required: true, message: '请输入门店名称' }]" -->
                        <div class="shop-form-field">
                            <van-field
                                v-model="fieldForm.storeName"
                                clearable
                                placeholder="请输入门店名称"
                                input-align="left"
                                error-message-align="left"
                                style="width: 240px;"
                                @blur="onFieldBlur('name', fieldForm.storeName)"
                                @focus="hideBotton()"
                                type="text"
                            />
                        </div>
                    </div>
                    <div class="shop-form-line"></div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label shop-form-count-label-not">
                            <text>门店电话</text>
                        </div>
                        <!-- :rules="[{ required: true, message: '请输入门店对外展示电话' }]" -->
                        <div class="shop-form-field" style="width: 100%;">
                            <van-field
                                v-model="fieldForm.phone"
                                placeholder="门店客服/预约电话"
                                clearable
                                input-align="left"
                                error-message-align="left"
                                type="tel"
                                :maxlength="30"
                                @blur="onFieldBlur('tel', fieldForm.phone ? fieldForm.phone : fieldForm.bossPhone)"
                                @focus="hideBotton()"
                            />
                        </div>
                    </div>
                    <div class="shop-form-line"></div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label">门店地址</div>
                        <!-- :rules="[{ required: true, message: '请选择门店地址' }]" -->
                        <div class="shop-form-field">
                            <van-field
                                v-model="fieldForm.areaCode"
                                placeholder="省、市、区"
                                input-align="left"
                                error-message-align="left"
                                style="width: 301px;"
                                is-link
                                readonly
                                @click="showArea = true"
                            />
                        </div>
                        <!-- <van-popup v-model:show="showArea" position="bottom">
                            <van-area
                                :area-list="areaList"
                                @confirm="onConfirm"
                                @cancel="showArea = false"
                            />
                        </van-popup> -->
                        <van-popup v-model:show="showArea" position="bottom">
                            <van-picker
                                :columns="columns"
                                @cancel="showArea = false"
                                @confirm="onConfirm"
                            />
                        </van-popup>

                    </div>
                    <div class="shop-form-line"></div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label">详细地址</div>
                        <div class="shop-form-field field-full-address">
                            <van-field
                                v-model="fieldForm.fullAddress"
                                clearable
                                placeholder="点击右侧图标选择门店位置"
                                input-align="left"
                                error-message-align="left"
                                style="width: 260px;"
                                @blur="onFieldBlur('address', fieldForm.fullAddress)"
                                type="textarea"
                                @focus="hideBotton()"
                            />
                            <img src="../../assets/position-icon.png" class="position-icon" alt="" @click="onShowMap">
                        </div>
                    </div>
                    <div class="shop-form-line"></div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label">经纬度</div>
                        <div class="shop-form-field" :class="fieldForm.position ? 'field-full-address' : ''">
                            <van-field
                                v-model="fieldForm.position"
                                clearable
                                placeholder="(填好地址系统自动获取)"
                                input-align="left"
                                error-message-align="left"
                                style="width: 240px;"
                                :disabled="true"
                            />
                        </div>
                    </div>

                    <div class="shop-form-line"></div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label" style="line-height: 40px;">LOGO/门头照</div>
                        <span v-if="fieldForm.storeLOGO.length < 1" class="shop-form-count-imgtips">建议宽高比例1:1</span>
                        <van-uploader
                            v-model="fieldForm.storeLOGO"
                            preview-size="40"
                            :max-count="1"
                            :before-delete="delStoreLogo"
                            :after-read="afterUpload"
                        />
                    </div>
                    <div class="shop-form-line"></div>


                    <div class="shop-form-count shop-form-count-one">
                        <div class="shop-form-count-label shop-form-count-sw" style="line-height: 80px;">营业执照</div>
                        <van-uploader
                            v-model="fieldForm.license"
                            preview-size="80"
                            :max-count="1"
                            :before-delete="delLicense"
                            :after-read="licenseUpload"
                        />
                    </div>
                    <div class="shop-form-line"></div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label shop-form-count-label-not">门店标签</div>

                        <div class="shop-form-field">
                            <van-field
                                v-model="fieldForm.labels"
                                placeholder="请添加标签"
                                input-align="left"
                                error-message-align="left"
                                style="width: 301px;"
                                is-link
                                readonly
                                @click="tagShow = true"
                            />
                        </div>
                    </div>
                    <div class="shop-form-line"></div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label shop-form-count-label-not">营业时间</div>
                        <div class="shop-form-field">
                            <!-- <van-field
                                v-model="fieldForm.businessHours"
                                placeholder="示例：周一至周日 10:00-22:00"
                                input-align="left"
                                error-message-align="left"
                                style="width: 270px;"
                                @blur="onFieldBlur('tradeTime', fieldForm.businessHours)"
                            /> -->
                            <van-field
                                v-model="fieldForm.businessHours"
                                placeholder="示例：周一至周日 10:00-22:00"
                                input-align="left"
                                error-message-align="left"
                                style="width: 301px;"
                                is-link
                                readonly
                                @click="showPicker = true"
                            />
                            <van-popup v-model:show="showPicker" position="bottom">
                                <van-picker
                                    ref="picker"
                                    @cancel="showPicker = false"
                                    :columns="pickerColumns"
                                    @change="onPickerChange"
                                    @confirm="onPickerConfirm" />
                            </van-popup>
                        </div>
                    </div>
                    <div class="shop-form-line"></div>

                    <div class="shop-form-count shop-form-bolck">
                        <div class="shop-form-count-label shop-form-count-label-not">门店介绍</div>
                        <div class="shop-form-field">
                            <van-field
                                v-model="fieldForm.remark"
                                rows="6"
                                autosize
                                type="textarea"
                                placeholder="请输入门店介绍，最多500字..."
                                maxlength="500"
                                @blur="onFieldBlur('remark', fieldForm.remark)"
                                @focus="hideBotton()"
                            />
                        </div>
                    </div>


                    <div class="shop-form-count shop-form-imgs">
                        <div class="shop-form-count-label shop-form-count-label-not">轮播头图</div>
                        <span style="line-height: 30px;" class="shop-form-count-imgtips">最多上传5张图片，宽高比建议16:9，可拖动排序</span>
                        <van-uploader
                            v-model="fieldForm.banners"
                            preview-size="80"
                            :max-count="5"
                            :after-read="seedingUpload"
                            :before-delete="delSeeding"
                            :multiple="true"
                        />
                    </div>

                    <div class="shop-form-count shop-form-imgs">
                        <div class="shop-form-count-label shop-form-count-label-not">店铺相册</div>
                        <span style="line-height: 30px;" class="shop-form-count-imgtips">最多上传9张，尺寸建议108x79px，可拖动排序</span>
                        <van-uploader
                            v-model="fieldForm.storeBanners"
                            preview-size="80"
                            :max-count="9"
                            :after-read="albumUpload"
                            :before-delete="delAlbum"
                            :multiple="true"
                        />
                    </div>
                    <div class="concat-btn" @click="openService(1)" v-show="2 == isRegrster">
                      <img class="concat-icon" src=".././../assets/concat.png" />
                    </div>
                    <div class="shop-form-btn" v-if="showSaveBotton">
                        <van-button style="border-radius: 8px;" block type="primary" native-type="submit" color="#0F50C5" :disabled="resdisabled">确认提交开店信息</van-button>
                    </div>
                </van-form>
            </div>
            <div class="edit">
                <van-popup
                    v-model:show="editPopup"
                    round
                >
                    <div class="c-modal">
                        <div class="c-modal-title">修改手机号</div>
                        <div class="c-modal-input">
                            <van-field
                                v-model="mePhone"
                                placeholder="请输入手机号"
                                style="width: 260px;"
                                type="tel"
                                :maxlength="11"
                            />
                        </div>
                        <div class="c-modal-input">
                            <van-field
                                v-model="meCode"
                                placeholder="请输入验证码"
                                type="digit"
                            >
                            <template #button>
                                <van-button size="small" @click="getCode(2)" type="default" :disabled="isSubSms">{{regesterText}}</van-button>
                            </template>
                            </van-field>
                        </div>
                        <div class="edit-btn">
                            <van-button type="danger" @click="editBtn" :disabled="editAbled">确认修改</van-button>
                        </div>
                    </div>
                </van-popup>
            </div>
        </div>

        <van-popup
            v-model:show="showVanPopup"
            closeable
            :safe-area-inset-bottom="true"
            position="bottom"
            round
            :style="{ height: '90%' }">
            <div class="popup-content">
                <img class="bg-img" src="../../assets/pic_2.png" />
                <div class="store-info">
                    <div class="store-name">
                        <img class="store-logo" :src="storeData.coverImage" />
                        <div class="name">{{ storeData.name }}</div>
                    </div>
                    <div class="borde-bottom-line"></div>
                    <div class="boss-info">
                        <p class="boss-name">店老板：{{ storeData.bossName }}</p>
                        <p>店老板手机号：{{ storeData.tel }}</p>
                    </div>
                </div>

                <div class="service-text">
                    <p>您可以使用手机号登录吉祥有约App进入门店</p>
                    <p>如有任何疑问可<text @click="openService(2)">点击联系客服</text>为您解决</p>
                </div>
                <div class="border-bottom"></div>
                <img class="introduce-img" src="@/assets/pic_3.png" />
                <div class="btn-group">
                    <div class="continue-btn btn" @click="showVanPopup = false">不是我的店，继续开店</div>
                    <div class="openapp-btn btn" @click="jumpApp">进入吉祥有约App</div>
                </div>
            </div>
        </van-popup>

        <div v-show="3 == isRegrster" class="shop-success">
            <div class="shop-success-img">
                <van-image
                    fit="cover"
                    :src="successImg"
                    class="shop-success-image"
                />
            </div>
            <div class="shop-success-text">开店成功</div>
            <div class="shop-success-btn">
                <div class="shop-success-btn-phone">使用账号“{{bossPhone}}”登录</div>
                <van-button block type="primary" color="#0F50C5" @click="jumpApp">进入门店管理后台</van-button>
            </div>
        </div>

        <van-action-sheet v-model:show="tagShow" title="选择标签">
            <div class="tags">
                <div class="tags-body">
                    <van-tag
                        v-for="(item, index) in restaurantsLabels"
                        :plain="!item.checked ? true : false"
                        :key="'tag' + item.index"
                        size="large"
                        type="primary"
                        @click="getLabel(item, index)"
                    >{{ item.value }}</van-tag>
                </div>
                <div class="tags-input">
                    <van-field
                        v-model="tagText"
                        placeholder="标签名称"
                        type="text"
                        maxlength="4"
                    />
                    <van-button icon="plus" size="mini" type="primary" @click="addTag(tagText)">添加</van-button>
                </div>
                <div class="tags-btn" @click="tagSubmit">确认</div>
            </div>
        </van-action-sheet>
        <AppMap
            v-if="showMap"
            :lnglat="fieldForm.position"
            :address="fieldForm.fullAddress"
            @getMapInfo="getMapInfo"
        />
    </div>
</template>
<script>
import { ref, getCurrentInstance, onMounted, onBeforeUnmount, computed } from 'vue';
import { isWeChat } from '@/utils/validate';
import { regionList } from '@/utils/util'
import { getUrlKey } from '@/utils/util'
import img1 from "@/assets/settle/sha_01.jpg"
import img2 from "@/assets/settle/sha_02.jpg"
import img3 from "@/assets/settle/sha_03.jpg"
import img4 from "@/assets/settle/sha_04.jpg"
import img5 from "@/assets/settle/sha_05.jpg"
import suc from '@/assets/success.png'
import { useRouter } from "vue-router";
import { useFieldForm } from './useHook/useFieldForm'
import { useMsgCode } from './useHook/useMsgCode'
import { useCache } from './useHook/useCache'
import { goToApp } from "@/utils/goToApp"
import { debounce } from '@/utils/util'
import AppMap from '../../components/app-map/index.vue'
import MonitorKeyboard from '../../utils/monitorKeyboard'
export default {
    name: "ShopInfo",
    data() {
        return
    },
    components: {
        AppMap
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const isWX = ref(isWeChat())
        const storeName = ref('');
        const phone = ref('');
        const bossName = ref('')
        const bossPhone = ref('')
        const address = ref('')
        const areaCode = ref('')
        const fullAddress = ref('')
        const storeLOGO = ref([])
        const license = ref([])
        const labels = ref('')
        const businessHours = ref('')
        const remark = ref('')
        const banners = ref([])
        const storeBanners = ref([])
        const ids = ref([])
        const names = ref([])
        let columns = ref([])
        const showPopup = ref(false)
        const position = ref([])
        const linkCode = ref(getUrlKey('code'))
        const proxySaleName = ref('')  // 服务商名称
        const proxySaleBrand = ref('') // 服务商品牌
        const smsCode = ref('') // 短信验证码
        const imgUrl = ref('https://image.jxt1314.com/h5')
        const pageScrollTop = ref(0)

        const regesterPhone = ref('')
        const regesterCode = ref('')
        const regesterText = ref('获取验证码')
        const isSubSms = ref(false)
        const loginBtn = ref(false)
        const editAbled = ref(false)
        const showArea = ref(false);
        const successImg = ref(suc)
        const settleList = ref([
            { url: img1 },
            { url: img2 },
            { url: img3 },
            { url: img4 },
            { url: img5 },
        ])
        const showMap = ref(false)
        const $router = useRouter();
        const showSaveBotton = ref(true)
        const monitorKeyboard = ref(null)
        const {
            setFieldValue,
            submitUserData,
            fieldForm,
            resdisabled,
            isRegrster,
            showPicker,
            pickerColumns,
            onPickerChange,
            onPickerConfirm,
            openService,
            verifyStore,
            picker,
            showProxySale,
            showVanPopup,
            storeData,
        } = useFieldForm()
        let { smsCodeText, getMsgCode, verifyMsgCode, msgCodeStatus } = useMsgCode()
        let { removeCache } = useCache()

        const restaurantsLabels = ref([
            { checked: false, value: '免费WIFI' },
            { checked: false, value: '免费停车' },
            { checked: false, value: '定制护理' },
            { checked: false, value: 'VIP专区' },
            { checked: false, value: '免费甜点' },
            { checked: false, value: '环境优雅' }
        ])

        const storeTags = ref([])
        const tagText = ref('')
        const tagShow = ref(false)

        const geoCode = (address) => {
            var geocoder = new AMap.Geocoder({
                city: "",
            });

            geocoder.getLocation(address, setCode);
        }
        const setCode = (status, result) => {
            if (status === 'complete' && result.geocodes.length) {
                    let location = [result.geocodes[0].location.lng, result.geocodes[0].location.lat]
                    onFieldBlur('position', location)
                    fieldForm.position = location
                } else {
                console.log('根据地址查询位置失败');
            }
        }

        const onFieldBlur = (key, value) => {
            showSaveBotton.value = true
            if(key == 'address') {
                if(value == '') {
                  onFieldBlur('position', '')
                  fieldForm.position = ''
                }
                geoCode(value)
            }
            setFieldValue(key, value)
        }

        const getLabel = (item, i) => {
            let eArr = restaurantsLabels.value
            let arr = storeTags.value
            let text = item.value
            let index = arr.indexOf(text)
            if(-1 != index) {
                arr.splice(index, 1)
                eArr[i].checked = false
            } else {
                if(arr.length == 5) {
                    proxy.$toast({
                        message: "最多只能添加五个标签",
                        duration: 1500,
                    });
                    return
                }
                arr.push(text)
                eArr[i].checked = true
            }
            storeTags.value = arr
            restaurantsLabels.value = eArr
        }

        const addTag = (tag) => {
            if (tag === '') {
                proxy.$toast({
                    message: '标签不能为空',
                    duration: 1000,
                })
                return
            }

            let eArr = restaurantsLabels.value
            let sArr = storeTags.value
            // if(sArr.length == 5) {
            //     proxy.$toast({
            //         message: "最多只能添加五个标签",
            //         duration: 1500,
            //     });
            //     return
            // }

            let arr = []
            eArr.forEach((item) => {
                arr.push(item.value)
            })
            let index = arr.indexOf(tagText.value)
            if(-1 != index) {
                proxy.$toast({
                    message: '标签已存在',
                    duration: 1500,
                })
                return
            } else {
                eArr.push({ checked: sArr.length < 5 ? true : false, value: tagText.value })
                if (sArr.length < 5) {
                    sArr.push(tagText.value)
                }
            }
            setTimeout(() => {
                restaurantsLabels.value = eArr
                storeTags.value = sArr
                tagText.value = ''
            }, 100)
        }

        const tagSubmit = () => {
            tagShow.value = false
            labels.value = storeTags.value.join('，')
            fieldForm.labels = storeTags.value.join('，')
            onFieldBlur('storeLabelList', storeTags.value)
        }


        //获取省市区
        const onConfirm = (selectedOptions) => {
            showArea.value = false;
            areaCode.value = selectedOptions.map((item) => item.text).join('/');
            fieldForm.areaCode = selectedOptions.map((item) => item.text).join('/');
            ids.value = selectedOptions.map((item) => item.value)
            console.log(ids.value)
            names.value = selectedOptions.map((item) => item.text)
            onFieldBlur(['provinceId', 'cityId', 'areaId', 'provinceName', 'cityName', 'areaName'], [...ids.value, ...names.value])
        }

        // logo
        const coverImage = ref('')

        const invitationName = ref('')
        const invitationText = ref('')

        ///store_settled/invitation_info
        const getInvitationInfo = () => {
            proxy.$http.post(
                'store_settled/invitation_info',
                { invitationCode: getUrlKey('code') },
                { headers: { 'content-type' : 'application/json; charset=utf-8' } }
            ).then(({ data: res }) => {
                if(res.success) {
                    setTimeout(() => {
                        invitationName.value = res.data.userName
                        invitationText.value = res.data.title
                    }, 800)
                } else {
                    proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        // 删除LOGO/门头照
        const delStoreLogo = () => {
            storeLOGO.value = []
            fieldForm.storeLOGO = []
            coverImage.value = ''
            onFieldBlur('coverImage', coverImage.value)
        }

        const afterUpload = (file) => {
            let form = new FormData();
            form.append("files", file.file);
            form.append('resp', 'list')
            proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
                if(res.success) {
                    coverImage.value = res.data[0]
                    onFieldBlur('coverImage', coverImage.value)
                }
            })
        }

        // 删除营业执照
        const delLicense = () => {
            license.value = []
            fieldForm.license = []
            licenseImage.value = ''
            onFieldBlur('licenseImage', licenseImage.value)
        }

        // 营业执照
        const licenseImage = ref('')
        const licenseUpload = (file) => {
            let form = new FormData();
            form.append("files", file.file);
            form.append('resp', 'list')
            proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
                if(res.success) {
                    licenseImage.value = res.data[0]
                    onFieldBlur('licenseImage', licenseImage.value)
                }
            })
        }

        // 轮播头图
        const bannerImage = ref([])
        let bannerasArr = []
        const seedingUpload = (file) => {
            const type = Array.isArray(file)
            let arr = []
            if (!type) {
                arr = [file.file]
            } else {
                arr = file.map((item) => item.file)
            }
            arr.forEach(item => {
                let form = new FormData();
                form.append("files", item);
                form.append('resp', 'list')
                proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
                    if(res.success) {
                        bannerasArr.push(res.data[0])
                        bannerImage.value = bannerasArr
                        onFieldBlur('bannerImage', bannerImage.value)
                    }
                })
            })

        }

        // 删除轮播图
        const delSeeding = (file, detail) => {
            let index = detail.index
            let arr = banners.value
            arr.splice(index, 1)
            bannerasArr.splice(index, 1)
            bannerImage.value = bannerasArr
            banners.value = arr
            onFieldBlur('bannerImage', bannerImage.value)
        }

        const albumImage = ref([])
        let albumArr = []
        const albumUpload = (file) => {
            const type = Array.isArray(file)
            let arr = []
            if (!type) {
                arr = [file.file]
            } else {
                arr = file.map((item) => item.file)
            }
            arr.forEach(item => {
                let form = new FormData();
                form.append("files", item);
                form.append('resp', 'list')
                proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
                    if(res.success) {
                        albumArr.push(res.data[0])
                        albumImage.value = albumArr
                        onFieldBlur('albumImage', albumImage.value)
                    }
                })
            })

        }

        // 删除门店相册
        const delAlbum = (file, detail) => {
            let index = detail.index
            let arr = storeBanners.value
            arr.splice(index, 1)
            albumArr.splice(index, 1)
            albumImage.value = bannerasArr
            storeBanners.value = arr
            onFieldBlur('albumImage', albumImage.value)
        }


        // const resdisabled = ref(false)
        const onSubmit = (values) => {
            if('' == storeName.value) {
                proxy.$toast.fail({
                    message: "请填写门店名称",
                    duration: 1500,
                });
                return
            }
            let re = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/
            // let tel =

            let test = re.test(phone.value)
            let testTel = tel.test(phone.value)
            // if('' == phone.value) {
            //     proxy.$toast.fail({
            //         message: "请填写门店电话",
            //         duration: 1500,
            //     });
            //     return
            // }
            if(!test) {
                proxy.$toast.fail({
                    message: "请填写正确的门店电话",
                    duration: 1500,
                });
                return
            }
            if('' == bossName.value) {
                proxy.$toast.fail({
                    message: "请填写店老板姓名",
                    duration: 1500,
                });
                return
            }
            if('' == bossPhone.value) {
                proxy.$toast.fail({
                    message: "请填写店老板电话",
                    duration: 1500,
                });
                return
            }
            if(0 == names.value.length) {
                proxy.$toast.fail({
                    message: "请填写门店地址",
                    duration: 1500,
                });
                return
            }

            if('' == coverImage.value) {
                proxy.$toast.fail({
                    message: "请上传LOGO/门头照",
                    duration: 1500,
                });
                return
            }

            if('' == licenseImage.value) {
                proxy.$toast.fail({
                    message: "请上传营业执照",
                    duration: 1500,
                });
                return
            }

            let params = {
                address: fullAddress.value,
                albumImage: albumImage.value,
                areaId: ids.value[2],
                areaName: names.value[2],
                bannerImage: bannerImage.value,
                bossName: bossName.value,
                bossPhone: bossPhone.value,
                cityId: ids.value[1],
                cityName: names.value[1],
                coverImage: coverImage.value,
                id: 154,
                invitationCode: linkCode.value,
                licenseImage: licenseImage.value,
                name: storeName.value,
                provinceId: ids.value[0],
                provinceName: names.value[0],
                remark: remark.value,
                storeLabelList: storeTags.value,
                tel: phone.value ? phone.value : bossPhone.value,
                telCode: regesterCode.value,
                tradeTime: businessHours.value,
                applyFrom: showProxySale.value ? 3 : 1,
            }
            resdisabled.value = true
            proxy.$toast.loading({
              message: '正在提交',
              duration: 1000,
            })
            proxy.$http.post('/store_settled/add', params, { headers: { 'content-type' : 'application/json; charset=utf-8' } }).then(({ data: res }) => {
                if(res.success) {
                    isRegrster.value = 3
                    removeCache('submitFormData')  // 提交后移除本地缓存的表单数据
                } else {
                    resdisabled.value = false
                    proxy.$toast.fail({
                        message: res.errorMessage,
                        duration: 1500,
                    });
                }
            })
        }

        let oldScrollTop = 0
        const scrollTop = ref(0)
        const scrollFixedStatus = ref(true)
        const flexBottom = ref(false)

        const windowHeight = ref(0)
        const getWindowResize = function () {
            windowHeight.value = window.innerHeight
        }

        function handleScroll() {
            window.addEventListener('scroll', debounce(() => {
                if (isRegrster.value == 1) {
                    pageScrollTop.value = window.scrollY
                }
            }, 20))
        }

        const fixedBtn = computed(() => pageScrollTop.value > 350)

        onBeforeUnmount(() => {
            window.removeEventListener('scroll', () => {})
            monitorKeyboard.value.onEnd()
        })

        function getUserMedia(constrains) {
            if (navigator.mediaDevices.getUserMedia) {
                // 最新标准API
                navigator.mediaDevices.getUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
            } else if (navigator.webkitGetUserMedia) {
                // webkit内核浏览器
                navigator.webkitGetUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
            } else if (navigator.mozGetUserMedia) {
                // Firefox浏览器
                navigator.mozGetUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
            } else if (navigator.getUserMedia) {
                // 旧版API
                navigator.getUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
            }
        }

        function success(stream) {
            console.log("已点击允许,开启成功");
            // alert('已点击允许,开启成功')
        }
        // 异常的回调函数
        function error(error) {
            console.log("访问用户媒体设备失败：", error.name, error.message);
            // alert(`访问用户媒体设备失败,${error.name, error.message}`)
        }


        onMounted(async () => {
            // getUserMedia({ video: true, audio: true })
            proxy.$http.get('/base/region').then(({ data: res }) => {
                columns.value = regionList(res.data)
            })
            handleScroll();
            getWindowResize()
            window.addEventListener('resize', getWindowResize)

            if (getUrlKey('regCode')) {
                isRegrster.value = 2
            }

            if (getUrlKey('code')) {
                getInvitationInfo()
            }
            getKeyboardState()
        })

        const getKeyboardState = () => {
            monitorKeyboard.value = new MonitorKeyboard();
            monitorKeyboard.value.onStart();

            // 监听虚拟键盘弹出事件
            monitorKeyboard.value.onShow(() => {
                showSaveBotton.value = false
            })

            //监听键盘收起的事件
            monitorKeyboard.value.onHidden(() => {
                showSaveBotton.value = true
            })
        }

        // 获取验证码    /store_settled/code
        const time = ref(60)
        let timer = ''
        const getCode = (type) => {
            let re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;

            if(1 == type) {
                if('' == regesterPhone.value) {
                    proxy.$toast.fail('请填写手机号');
                    return
                }
                let result = re.test(regesterPhone.value);
                if(!result) {
                    proxy.$toast.fail('请填写正确格式的手机号码');
                    return ;
                }
            }
            if( 2 == type) {
                if('' == mePhone.value) {
                    proxy.$toast.fail('请填写手机号');
                    return
                }
                let result = re.test(mePhone.value);
                if(!result) {
                    proxy.$toast.fail('请填写正确格式的手机号码');
                    return ;
                }
            }
            isSubSms.value = true
            proxy.$http.post('/store_settled/code', { phone: 1 == type ? regesterPhone.value : mePhone.value }).then(({ data: res }) => {
                if(res.success && res.data.status == 2) {
                    settleStatus.value = true
                    setTimeout(() => {
                        $router.push({ path: "/downapk" });
                    }, 2000)
                    return
                }

                if(res.success) {
                    proxy.$toast.success('验证码已发送');
                    let num = time.value
                    timer = setInterval(() => {
                        if(num > 0) {
                            num--
                            regesterText.value = num + 's'
                            time.value = num
                        } else {
                            regesterText.value = '重新获取'
                            time.value = 60
                            isSubSms.value = false
                            clearInterval(timer)
                        }
                    }, 1000)
                } else {
                    setTimeout(() => {
                        isSubSms.value = false
                        regesterText.value = '获取验证码'
                    })
                    proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        const settleStatus = ref(false)
        // 门店客户登录  /store_settled/login
        const login = () => {
            if('' == regesterPhone.value) {
                proxy.$toast.fail('请填写手机号');
                return
            }

            if('' == regesterCode.value) {
                proxy.$toast.fail('请填写验证码');
                return
            }
            loginBtn.value = true
            proxy.$toast.loading({
                message: '正在登录',
                duration: 1500,
            })
            proxy.$http.post('/store_settled/login', { phone: regesterPhone.value, code: regesterCode.value }).then(({ data: res }) => {
                loginBtn.value = false
                if(res.success) {
                    if(2 == res.data.status && res.data.status) {
                        setTimeout(() => {
                            settleStatus.value = true
                            showPopup.value = false
                            editPopup.value = false
                            bossPhone.value = regesterPhone.value
                        }, 1000)
                    } else {
                        setTimeout(() => {
                            isRegrster.value = 2
                            showPopup.value = false
                            editPopup.value = false
                            bossPhone.value = regesterPhone.value
                            settleStatus.value = false
                        }, 1000)
                    }
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                } else {
                    proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        // 跳转App  /h5/jump_app
        const jumpApp = () => {
            setTimeout(() => {
                if (getUrlKey('regCode') === '2') {
                    goToApp(storeData.tel)
                } else {
                    // $router.push({ path: "/downapk" });
                    try {
                        window.jxyy.goToLogin()
                    } catch (error) {
                        $router.push({ path: "/downapk" });
                    }
                }
            }, 2000)
        }

        // 修改手机号
        const editPhone = () => {
            editPopup.value = true
            clearInterval(timer)
            time.value = 60
            isSubSms.value = false
            regesterText.value = '获取验证码'
        }
        const editPopup = ref(false)

        const mePhone = ref('')
        const meCode = ref('')

        const editBtn = () => {
            if('' == mePhone.value) {
                proxy.$toast.fail('请填写手机号');
                return
            }

            if('' == meCode.value) {
                proxy.$toast.fail('请填写验证码');
                return
            }
            editAbled.value = true
            proxy.$toast.loading({
                message: '修改中',
                duration: 1500,
            })
            proxy.$http.post('/store_settled/login', { phone: mePhone.value, code: meCode.value }).then(({ data: res }) => {
                editAbled.value = false
                if(res.success) {
                    if(2 == res.data.status && res.data.status) {
                        setTimeout(() => {
                            settleStatus.value = true
                            showPopup.value = false
                            editPopup.value = false
                        }, 1000)
                    } else {
                        setTimeout(() => {
                            editPopup.value = false
                            bossPhone.value = mePhone.value
                            regesterCode.value = meCode.value
                        }, 1000)
                    }
                } else {
                    proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        const getMapInfo = (map) => {
            if(!map.fullAddress) {
                showMap.value = false
                return
            }
            onFieldBlur('address', map.fullAddress)
            onFieldBlur('position', map.position.join(','))
            showMap.value = false
            fieldForm.fullAddress = map.fullAddress

        }

        const hideBotton = () => {
            showSaveBotton.value = false
        }

        const onShowMap = () => {
            showMap.value = true
        }

        const settleIn = () => {
            isRegrster.value = 2
            // showPopup.value = true;
        }

        return {
            fieldForm,
            smsCode,
            proxySaleName,
            proxySaleBrand,
            storeName,
            phone,
            bossName,
            bossPhone,
            address,
            areaCode,
            fullAddress,
            showArea,
            columns,
            storeLOGO,
            license,
            labels,
            businessHours,
            remark,
            banners,
            storeBanners,
            isRegrster,
            successImg,
            coverImage,
            licenseImage,
            showPopup,
            regesterPhone,
            regesterCode,
            regesterText,
            flexBottom,
            settleList,
            isSubSms,
            settleStatus,
            invitationName,
            invitationText,
            editPopup,
            mePhone,
            meCode,
            restaurantsLabels,
            tagShow,
            tagText,
            resdisabled,
            editAbled,
            isWX,
            smsCodeText,
            msgCodeStatus,
            showPicker,
            pickerColumns,
            imgUrl,
            fixedBtn,
            position: [],
            onPickerChange,
            onPickerConfirm,
            openService,
            verifyStore,
            picker,
            showProxySale,
            showVanPopup,
            storeData,
            showMap,
            showSaveBotton,
            verifyMsgCode,
            submitUserData,
            onSubmit,
            onConfirm,
            jumpApp,
            afterUpload,
            seedingUpload,
            licenseUpload,
            albumUpload,
            getCode,
            login,
            editPhone,
            editBtn,
            getLabel,
            tagSubmit,
            addTag,
            delSeeding,
            delAlbum,
            settleIn,
            onFieldBlur,
            getMsgCode,
            delStoreLogo,
            delLicense,
            getMapInfo,
            onShowMap,
            hideBotton
        }
    },



}
</script>

<style scoped lang="scss" src="./index.scss"></style>
